export default {
  questions: {
    openConversational: {
      openEndPlaceholder: 'Please enter your text here',
      conversationalPlaceholder: 'Please enter your response here',
      conversationClosed: 'Conversation closed.',
      conversationalDisclaimer: 'Follow-up questions will be generated by AI based on your responses.'
    },
    openText: {
      openEndPlaceholder: 'Please enter your text here'
    },
    multiText: {
      fieldPlaceholder: 'Answer {number}',
      instruction: 'Type at least {count} answer below, one per text box | Type at least {count} answers below, one per text box',
      instructionWithoutMinimum: 'Type your answers below, one per text box',
      minimumEntries: 'Please enter at least {count} answer to continue. | Please enter at least {count} answers to continue.',
      unaidedBrandAwareness: {
        fieldPlaceholder: 'Brand {number}',
        minimumEntries: 'Please enter at least {count} brand to continue. | Please enter at least {count} brands to continue.'
      }
    },
    multiselect: {
      caption: 'Select all that apply'
    },
    rankOrder: {
      enterRankOrder: 'Enter Rank Order',
      placeholder: 'Drag your choices here to rank them'
    },
    openNumeric: {
      label: 'Open Numeric'
    },
    complete: {
      message: 'Thank you for completing this survey.'
    },
    openVideo: {
      warning: 'Please record a video before proceeding.',
      uploadStatusUploading: 'Please wait until we process your video to continue...',
      uploadStatusSuccess: 'Upload Successful, you can continue.',
      uploadStatusError: 'Upload not completed, please try again.'
    }
  },
  errors: {
    node: {
      text_invalid_email: 'Please enter a valid email address',
      text_invalid_phone: 'Please enter a valid phone number',
      text_invalid_us_zip: 'Please enter a valid US ZIP code',
      text_invalid_ca_postal: 'Please enter a valid Canadian postal code',
      text_invalid_uk_postal: 'Please enter a valid UK postcode',
      text_invalid_custom: 'Please enter a valid {fieldName}',
      text_min_chars: 'Please enter at least {min} characters',
      text_max_chars: 'Please enter no more than {max} characters',
      text_alpha_not_allowed: 'Only numeric characters are allowed',
      text_numeric_not_allowed: 'Only alphabetic characters are allowed'
    },
    external: {
      invalid: 'The answer to this question is not valid.',
      required: 'This question must be answered.',
      incomplete: 'Please fully complete this question before continuing.',
      singlechoice_required: 'Please select an option before proceeding.',
      numeric_required: 'Please select a rating before proceeding.',
      text_required: 'Please enter a response before proceeding.',
      bigtext_required: 'Please enter a response before proceeding.',
      singlechoiceother_incomplete: 'Please enter a response before proceeding.',
      multiselectother_incomplete: 'Please enter a response before proceeding.',
      numeric_invalid: 'Please enter a valid number before proceeding.',
      text_invalid: 'Please enter a valid response before proceeding.',
      bigtext_invalid: 'Please enter a valid response before proceeding.',
      radiogrid_required: 'Please select an option for each row before proceeding.',
      rankorder_min: 'Please rank at least {value} items before proceeding.',
      rankorder_max: 'Please rank no more than {value} items before proceeding.',
      multiselect_min: 'Please select at least {value} options before proceeding.',
      multiselect_max: 'Please select no more than {value} options before proceeding.',
      multiselectother_min: 'Please select at least {value} options before proceeding.',
      multiselectother_max: 'Please select no more than {value} options before proceeding.',
      multiselectgrid_min: 'Please select at least {value} options for each row before proceeding.',
      multiselectgrid_max: 'Please select no more than {value} options for each row before proceeding.'
    }
  }
}
